import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=06ff8e8e"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=06ff8e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports